export class APITimeoutException extends Error {
    constructor() {
        super();
        this.name = "APITimeoutException";
        this.message= "API timeout";
    }
}